import { useCallback } from "react";
import { createRoot } from "react-dom/client";
import SessionExpirationPopup from "../components/SeesionExpirePopup";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function useSessionExpiration() {
    const navigate = useNavigate();
    const { t } = useTranslation('translation', { keyPrefix: "otpScreen" });

    const show = useCallback((session: boolean) => {
        const edfapayAlert = document.getElementById('edfapay-alert') as HTMLElement;
        const alertRoot = createRoot(edfapayAlert);
        const HandleclearPopup = () => {
            if (edfapayAlert.hasChildNodes()) {
                edfapayAlert.removeChild(edfapayAlert.children[0]);
            }
            navigate("/login")
        }

        alertRoot.render(<SessionExpirationPopup session={session} message={t("ExpiryMessage")} title={t("sessionExpired")} buttonTxt={t("login")} handleLogout={HandleclearPopup} />
        )
    }
        , [])

    return { show };
}